import { useEffect } from 'react';
import { authService } from '../services/api';

// Sends a heartbeat every 60 s to keep the server-side session alive.
// The server expires sessions after 120 s without a heartbeat, so a missed
// beat (e.g. slow network) still has a 60-second grace period.
// When the backend returns 401 (session expired / limit reached) the response
// interceptor in api.js clears localStorage and redirects to /login automatically.
const SessionGuard = () => {
  useEffect(() => {
    const beat = () => {
      if (localStorage.getItem('token')) {
        authService.heartbeat().catch(() => {});
      }
    };

    beat(); // immediate beat on mount
    const id = setInterval(beat, 60_000);
    return () => clearInterval(id);
  }, []);

  return null;
};

export default SessionGuard;
